import './Footer.css';

const Footer = () => (
  <footer className="footer">
    <p>Made with love by Mariano Segura :)</p>
  </footer>
);

export default Footer;
